import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { Person } from "../../models/person.model";
import { PersonService } from "../../services/person.service";

@Component({
  selector: "ngx-dialog-link-person",
  templateUrl: "dialog-link-person.component.html",
  styleUrls: ["dialog-link-person.component.scss"],
})
export class DialogLinkPersonComponent implements OnInit {
  @Input() header: string;
  @Input() shopId?: string;
  @Input() linkPersonId: string;
  @Input() persons?: Person[];
  @Input() customerId?: string;
  @Input() supplierId?: string;
  @Input() employeeId?: string;

  diaForm: FormGroup;
  loading = false;
  submitted = false;
  strSearch = "";
  mobile = "";

  constructor(
    protected ref: NbDialogRef<DialogLinkPersonComponent>,
    private fb: FormBuilder,
    private personService: PersonService
  ) {}

  ngOnInit() {
    const fullNameValidators = [
      Validators.minLength(1),
      Validators.maxLength(250),
      Validators.required,
    ];
    const mobileValidators = [Validators.required];
    this.diaForm = this.fb.group({
      fullName: ["", fullNameValidators],
      mobile: ["", mobileValidators],
    });
  }

  cancel() {
    this.ref.close();
  }

  //Create
  create() {
    let cus = new Person();
    cus.shopId = this.shopId;
    cus.fullName = this.strSearch.trim();
    cus.mobile = this.mobile.trim();
    cus.customerId = this.customerId ? this.customerId : "";
    cus.supplierId = this.supplierId ? this.supplierId : "";
    cus.employeeId = this.employeeId ? this.employeeId : "";

    if (cus.fullName.length > 0) {
      this.loading = true;
      this.submitted = true;

      this.personService
        .create(cus)
        .then((data) => {
          this.selected(JSON.parse(JSON.stringify(data)));
        })
        .catch((err) => {
          this.loading = false;
          this.submitted = false;
        });
    }
  }

  selected(item) {
    this.submitted = true;
    this.ref.close(item);
  }

  removeLink() {
    this.submitted = true;
    const value = {
      id: "",
    };
    this.ref.close(value);
  }
}
